import { Grid, useMediaQuery } from "@mui/material";
import Layout from "../../components/Layout";
import PageTitle from "../../components/PageTitle";
import { TableSearch } from "../../components/Table/TableActions";
import Table from "../../components/Table/Table";
import { Icon } from "@iconify/react";
import Button from "../../components/Button";
import { useNavigate } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import { httprequest } from "../../data/api";
import { toast } from "react-toastify";
import InputGroup from "../../components/FormComponent/InputGroup";
import Modal from "../../components/Modal";
import Select from "react-select";
import useStyles from "./style";
import PopModal from "../../components/PopupModal/PopModal";

const GUARDIAN_ENDPOINT = "/api/v1/guardians";
const STUDENTS_ENDPOINT = "/api/v1/students";
const EMPLOYEE_ENDPOINT = "/api/v1/employees";

const EmailSubscriber = () => {
  const classes = useStyles();
  const isMobile = useMediaQuery("(max-width:600px)");
  const navigate = useNavigate();
  const [subscriberData, setSubscriberData] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [listName, setListName] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [editSubscriber, setEditSubscriber] = useState({ id: "", name: "" });
  const [deleteId, setDeleteId] = useState(null);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [selectedUserGroup, setSelectedUserGroup] = useState(null);
  const [members, setMembers] = useState([]);
  const [selectedMembers, setSelectedMembers] = useState([]);
  const [manualName, setManualName] = useState("");
  const [manualEmail, setManualEmail] = useState("");
  // eslint-disable-next-line no-unused-vars
  const [manualMembers, setManualMembers] = useState([]);
  const [manually, setManually] = useState(false);

  const userGroupOptions = [
    { value: "employees", label: "Employees" },
    { value: "guardians", label: "Guardians" },
    { value: "students", label: "Students" }
  ];
  const fetchSubscriberData = () => {
    httprequest
      .get("/api/v1/email-sub")
      .then((res) => {
        setSubscriberData(res.data.data);
      })
      .catch(() => {
      });
  };

  useEffect(() => {
    fetchSubscriberData();
  }, []);

  const toggleEditModal = (row = null) => {
    if (row) {
      setEditSubscriber({ id: row.id, name: row.name });
    }
    setIsEditModalOpen(!isEditModalOpen);
  };

  const handleEditSubscriber = () => {
    setIsLoading(true);

    httprequest
      .patch(`/api/v1/email-sub/${editSubscriber.id}`, { name: editSubscriber.name })
      .then((res) => {
        toast.success(res.data.message);
        fetchSubscriberData();
        setIsEditModalOpen(false);
      })
      .catch((error) => {
        toast.error(error.response?.data?.message || "Error updating subscriber");
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const toggleDeleteModal = (id) => {
    setDeleteId(id);
    setIsDeleteModalOpen(!isDeleteModalOpen);
  };

  const handleDeleteSubscriber = () => {
    setIsLoading(true);

    httprequest
      .delete(`/api/v1/email-sub/${deleteId}`)
      .then((res) => {
        toast.success(res.data.message);
        fetchSubscriberData(); // Refresh table
        setIsDeleteModalOpen(false);
      })
      .catch((error) => {
        toast.error(error.response?.data?.message || "Error deleting subscriber");
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const fetchMembers = (userGroup) => {
    let endpoint;
    switch (userGroup) {
    case "employees":
      endpoint = EMPLOYEE_ENDPOINT;
      break;
    case "guardians":
      endpoint = GUARDIAN_ENDPOINT;
      break;
    case "students":
      endpoint = STUDENTS_ENDPOINT;
      break;
    default:
      return;
    }

    httprequest
      .get(endpoint)
      .then((res) => {
        let formattedMembers;

        switch (userGroup) {
        case "employees":
          formattedMembers = res.data.data.employees.map((employee) => ({
            value: `${employee.first_name} ${employee.last_name}`,
            label: `${employee.first_name} ${employee.last_name}`,
            email: employee.email
          }));
          break;

        case "guardians":
          formattedMembers = res.data.data.map((guardian) => ({
            value: `${guardian.first_name} ${guardian.last_name}`,
            label: `${guardian.first_name} ${guardian.last_name}`,
            email: guardian.email
          }));
          break;

        case "students":
          formattedMembers = res.data.data.map((student) => ({
            value: `${student.student.first_name} ${student.student.last_name}`,
            label: `${student.student.first_name} ${student.student.last_name}`,
            email: student.email
          }));
          break;

        default:
          formattedMembers = [];
          break;
        }

        setMembers(formattedMembers);
      })
      .catch(() => {
        toast.error("Failed to fetch members.");
      });
  };

  // Add these functions
  const AddManually = () => {
    setManually(!manually);
  };

  const [selectedMembersByGroup, setSelectedMembersByGroup] = useState({
    employees: [],
    guardians: [],
    students: []
  });

  const handleUserGroupChange = (selectedOption) => {
    if (selectedUserGroup) {
      setSelectedMembersByGroup((prev) => ({
        ...prev,
        [selectedUserGroup.value]: selectedMembers
      }));
    }

    setSelectedUserGroup(selectedOption);
    fetchMembers(selectedOption.value);
    setSelectedMembers(selectedMembersByGroup[selectedOption.value] || []);
  };

  const membersWithSelectAll = [
    { value: "select-all", label: "Select All" },
    ...members
  ];

  const selectRef = useRef(null);

  const handleMemberChange = (selectedOptions) => {
    const isSelectAll = selectedOptions.some((option) => option.value === "select-all");

    if (isSelectAll) {
      setSelectedMembers(members);
      if (selectRef.current) {
        selectRef.current.blur();
      }
    } else {
      setSelectedMembers(selectedOptions || []);
    }

    if (selectedUserGroup) {
      setSelectedMembersByGroup((prev) => ({
        ...prev,
        [selectedUserGroup.value]: selectedOptions || []
      }));
    }
  };

  const columns = [
    {
      name: "List Name",
      selector: (row) => (
        <>
          {isMobile && <p className="mobile-styling">List Name</p>}
          {row?.name}
        </>
      )
    },
    {
      name: "Subscriber",
      selector: (row) => (
        <>
          {isMobile && <p className="mobile-styling">Subscriber</p>}
          {row.subscriber_count}
        </>
      )
    },
    {
      name: "",
      center: "true",
      sortable: false,
      cell: (row) => (
        <div key={row?.id} className="table-action-container">
          <button onClick={() => navigate(`/messaging/subscriberdetails/${row.id}`)} className="table-action-icon">
            <Icon icon="hugeicons:view" />
          </button>
          <button
            className="table-action-icon"
            onClick={() => toggleEditModal(row)}
          >
            <Icon icon="lucide:edit" />
          </button>

          <button className="table-action-icon" onClick={() => toggleDeleteModal(row.id)}>
            <div className="delete-icon"><Icon icon="mingcute:delete-2-line" /></div>
          </button>

        </div>
      )
    }
  ];

  const handleManualNameChange = (e) => {
    setManualName(e.target.value);
  };

  const handleManualEmailChange = (e) => {
    setManualEmail(e.target.value);
  };

  /**
   * Handles the creation of a new subscriber list.
   * Validates the input fields and sends a POST request to create the list.
   * If successful, it updates the subscriber data and resets the form fields.
   * @param {Event} e - The event object from the form submission.
   * @returns {void}
   */
  const handleCreateSubscriberList = () => {
    setIsLoading(true);
    setManualMembers((prevManualMembers) => {
      const updatedManualMembers = manualName && manualEmail
        ? [...prevManualMembers, { name: manualName, email: manualEmail }]
        : prevManualMembers;

      if (!selectedMembers.length && !updatedManualMembers.length) {
        toast.error("Please add at least one member.");
        setIsLoading(false);

        return;
      }

      const newList = {
        name: listName,
        user_group: selectedUserGroup,
        members: [
          ...selectedMembers.map((member) => ({
            name: member.label,
            email: member.email
          })),
          ...updatedManualMembers
        ]
      };

      httprequest
        .post("/api/v1/email-sub", newList)
        .then((res) => {
          toast.success(res.data.message);
          setIsModalOpen(false);
          fetchSubscriberData();
          setManualName("");
          setManualEmail("");
        })
        .catch((err) => {
          toast.error(err.response.data.message);
        })
        .finally(() => {
          setIsLoading(false);
        });

      return updatedManualMembers;
    });
  };

  return (
    <Layout children={
      <>
        <PageTitle
          title="Subscribers"
          subtitle="You can manage your emails and subscription here."
          button={
            <div className="flex gap-10">
              <PopModal title="Subcribers" videoUrl="https://youtu.be/F9xMcXnX5CU" />
              <Button
                variant="primary"
                buttonSize="fluid"
                color="btndefault"
                buttonName="Create Subscriber List"
                onClick={() => setIsModalOpen(true)}
              />
            </div>
          }
        />
        <div className="page-content">
          <Table
            data={subscriberData}
            columns={columns}
            pagination
            subHeader={true}
            subHeaderComponent={
              <TableSearch
                placeholder="Search subscribers..."
              />
            }
          />
        </div>

        <Modal
          title="Create Subscriber List"
          subtitle="Add a new subscriber list."
          modalContent={
            <Grid container spacing={2} className="input-padding">
              <Grid item lg={12} md={12} sm={12} xs={12}>
                <InputGroup
                  label="Subcriber List Name"
                  margin="normal"
                  required
                  placeHolder="Enter list name"
                  inputType="text"
                  onChange={(e) => setListName(e.target.value)}
                  value={listName}
                />
              </Grid>

              <Grid item lg={12} md={12} sm={12} xs={12}>
                <div className="multiple-select">
                  <p>
                  Select User Group
                    <span className="input-required"> * </span>
                  </p>
                  <Select
                    name="Select User Group"
                    options={userGroupOptions}
                    value={selectedUserGroup}
                    onChange={handleUserGroupChange}
                    required
                    closeMenuOnSelect={true}
                    menuPortalTarget={document.body}
                    styles={{
                      menuPortal: base => ({ ...base, zIndex: 9999 })
                    }}
                  />
                </div>
              </Grid>

              <Grid item lg={12} md={12} sm={12} xs={12}>
                <div className="multiple-select">
                  <p>
                    Members
                    <span className="input-required"> * </span>
                  </p>
                  <Select
                    name="members"
                    ref={selectRef}
                    options={membersWithSelectAll}
                    isMulti
                    value={selectedMembers}
                    onChange={handleMemberChange}
                    required
                    closeMenuOnSelect={false}
                    menuPortalTarget={document.body}
                    styles={{
                      menuPortal: base => ({ ...base, zIndex: 9999 })
                    }}
                    isClearable
                    isSearchable
                  />
                </div>
              </Grid>
              <div
                className={`${classes.mail} flex align-items-center`}
                onClick={AddManually}
              >
                <Icon icon="octicon:feed-plus-16" width="16" height="16" />
                <p>Add Manually</p>
              </div>
              {manually &&
               <>
                 <Grid item lg={12} md={12} sm={12} xs={12}>
                   <InputGroup
                     inputType="text"
                     label="Name"
                     inputName="manualname"
                     value={manualName}
                     onChange={handleManualNameChange}
                   />
                 </Grid>
                 <Grid item lg={12} md={12} sm={12} xs={12}>
                   <InputGroup
                     inputType="email"
                     label="Email"
                     inputName="manualEmail"
                     value={manualEmail}
                     onChange={handleManualEmailChange}
                   />
                 </Grid>
               </>}
            </Grid>
          }
          modalFooter={
            <>
              <Button
                variant="primary"
                buttonSize="full"
                color="btndefault"
                buttonName="Create List"
                isLoading={isLoading}
                onClick={handleCreateSubscriberList}
              />
            </>
          }
          isopen={isModalOpen}
          closeModal={() => setIsModalOpen(false)}
        />
        <Modal
          title="Edit Subscriber List"
          subtitle="Update the subscriber list name."
          modalContent={
            <>
              <InputGroup
                label="List Name"
                margin="normal"
                required
                placeHolder="Enter new list name"
                inputType="text"
                onChange={(e) => setEditSubscriber({ ...editSubscriber, name: e.target.value })}
                value={editSubscriber.name}
              />
            </>
          }
          modalFooter={
            <>
              <Button
                variant="primary"
                buttonSize="full"
                color="btndefault"
                buttonName="Update List"
                isLoading={isLoading}
                onClick={handleEditSubscriber}
              />
            </>
          }
          isopen={isEditModalOpen}
          closeModal={() => setIsEditModalOpen(false)}
        />
        <Modal
          title="Delete Subscriber List"
          subtitle="Are you sure you want to delete this list?"
          modalFooter={
            <>
              <Button
                variant="danger"
                buttonSize="full"
                color="btndefault"
                buttonName="Delete"
                isLoading={isLoading}
                onClick={handleDeleteSubscriber}
              />
            </>
          }
          isopen={isDeleteModalOpen}
          closeModal={() => setIsDeleteModalOpen(false)}
        />

        {/* <ToastContainer /> */}
      </>
    }
    />
  );
};

export default EmailSubscriber;
